(function () {
    'use strict';

    // @ngInject
    Services.jstz = function ($window) {
        return $window.jstz;
    };

}());
